import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { CryptoStorageService } from '@services/storage-service.service';
import { ICompany } from '../../interfaces/company.interface';

@Injectable({
  providedIn: 'root'
})
export class CompanySwitcher {
  private selectedCompany: BehaviorSubject<ICompany>;

  constructor(private cryptoStorageService: CryptoStorageService) {
    const storedCompany = this.cryptoStorageService.getFromSessionStorage('S_COMPANY');
    if (storedCompany) {
      this.selectedCompany = new BehaviorSubject(storedCompany);
    } else {
      this.selectedCompany = new BehaviorSubject(null);
    }
  }

  getSelectedCompanyValue(): ICompany {
    return this.selectedCompany.getValue();
  }

  getSelectedCompany(): Observable<ICompany> {
    return this.selectedCompany.asObservable();
  }

  setSelectedCompany(company: ICompany): void {
    if (company?.bin) {
      this.cryptoStorageService.setToSessionStorage('S_COMPANY', company);
    }
    this.selectedCompany.next(company);
  }
}
